import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { Barcode, BarcodeQuery, BarcodeService, BalanceQuery, config } from '@fgb/core';

@Component({
  selector: 'fgb-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
})
export class MobileHeaderComponent implements OnInit {
  @Input() titleKey: string;
  @Input() titleDefault: string;
  @Input() isProfilePage = false;

  @ViewChild('qrModal') qrModalRef: TemplateRef<any>;

  points$: Observable<number | undefined>;
  barcode$: Observable<Barcode>;

  constructor(
    private location: Location,
    private modalService: NgbModal,
    private balanceQuery: BalanceQuery,
    private barcodeQuery: BarcodeQuery,
    private barcodeService: BarcodeService
  ) {}

  ngOnInit() {
    this.points$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.barcode$ = this.barcodeQuery.select();
    this.barcodeService.fetchBarcode().toPromise();
  }

  goBack() {
    this.location.back();
  }

  openQrModal() {
    this.modalService.open(this.qrModalRef, { centered: true });
  }
}
